/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n() {
  return [0, 0, 0];
}

function t(n) {
  return [n[0], n[1], n[2]];
}

function r(n, t, r) {
  return [n, t, r];
}

function e(t) {
  var r = n(),
      e = Math.min(3, t.length);

  for (var _n = 0; _n < e; ++_n) {
    r[_n] = t[_n];
  }

  return r;
}

function u(n, t) {
  return new Float64Array(n, t, 3);
}

function a() {
  return n();
}

function o() {
  return r(1, 1, 1);
}

function s() {
  return r(1, 0, 0);
}

function c() {
  return r(0, 1, 0);
}

function i() {
  return r(0, 0, 1);
}

var f = a(),
    l = o(),
    _ = s(),
    N = c(),
    O = i(),
    U = Object.freeze({
  __proto__: null,
  create: n,
  clone: t,
  fromValues: r,
  fromArray: e,
  createView: u,
  zeros: a,
  ones: o,
  unitX: s,
  unitY: c,
  unitZ: i,
  ZEROS: f,
  ONES: l,
  UNIT_X: _,
  UNIT_Y: N,
  UNIT_Z: O
});

export { l as O, O as U, f as Z, t as a, u as b, n as c, e as d, s as e, r as f, c as g, _ as h, N as i, o, i as u, U as v, a as z };